import { Injectable, Output, EventEmitter } from '@angular/core';
// import { TabService } from '../tab.service';
import { PdfInstanceManagerService } from '../instance/pdf-instance-manager.service';
import { PdfToolType, PdfTools, CustomDocviewerCursorStyles } from 'src/app/core/pdf-utils/enums';
import { getToolNameByType } from 'src/app/core/pdf-utils/drawing-utils';
import { resetCursorIcon, documentElement, aplliedCursorStyle } from 'src/app/core/common';
import { Core } from '@pdftron/webviewer';


export enum ToolEventSource {
  Drawing = 'Drawing',
  RectangleSelection = 'RectangleSelection',
  Markers = 'Markers',
  Notes = 'Notes',
  Eraser = 'Eraser'
}

@Injectable({
  providedIn: 'root'
})
export class DocumentToolsService {
  private defaultToolMode: PdfTools = PdfTools.AnnotationEdit;
  private currentToolMode: ToolEventSource | null = null;

  @Output() toolToggled: EventEmitter<ToolEvent | null> = new EventEmitter();

  // private get docViewer(): CoreControls.DocumentViewer | null {
  //   return this.tabService.activeTab && this.tabService.activeTab.id
  //     ? this.pdfInstanceManager.getDocViewer(this.tabService.activeTab.id)
  //     : null;
  // }

  // private get documentId(): string | null {
  //   return this.tabService.activeTab ? this.tabService.activeTab.id : null;
  // }

  constructor(
    private readonly pdfInstanceManager: PdfInstanceManagerService,
    // private readonly tabService: TabService,
  ) { }

  isToolEnabled(tool: ToolEventSource): boolean {
    return tool === this.currentToolMode;
  }

  enableTool(source: ToolEventSource, shape: PdfToolType | null = null, styles: any = null): Promise<boolean> {
    return new Promise((resolve) => 
    {
      setTimeout(() => {
        const ids = this.pdfInstanceManager.getAllPdfInstancesIDs();
        ids.forEach(id => {
          this.enbaleToolForDoc(id, source, shape, styles);
        });

        resolve(true);
      }, 50);
    });
  }

  disableTool(source: ToolEventSource): void {
    const ids = this.pdfInstanceManager.getAllPdfInstancesIDs();
    ids.forEach(id => {
      this.disableToolForDoc(id, source);
    });
  }

  private disableToolForDoc(docId: string, source: ToolEventSource) {
    let docViewer = this.pdfInstanceManager.getDocViewer(docId);
    if (!docViewer || !docId) {
      return;
    }

    const currentToolMode = docViewer.getToolMode().name;

    if (docId) {
      const documentEl = documentElement(docId);

      if (!documentEl) {
        return;
      }
      if (source === ToolEventSource.Notes && currentToolMode !== PdfTools.Pan) {
        return;
      }

      if (currentToolMode !== this.defaultToolMode) {
        const tool = docViewer.getTool(this.defaultToolMode);
        const cursor = aplliedCursorStyle(docId);
        let cursorname = `cursor-${CustomDocviewerCursorStyles.audiomaker}`;
        if (cursor && cursorname !== cursor) {
          resetCursorIcon(docId);
        }
        docViewer.setToolMode(tool);
      }

      this.currentToolMode = null;

      this.toolToggled.emit({ source, isEnabled: false });
    }
  }

  private enbaleToolForDoc(docId: string, source: ToolEventSource, shape: PdfToolType | null = null, styles: any = null) {
    let docViewer = this.pdfInstanceManager.getDocViewer(docId);
    if (!docViewer || !docId) {
      return false;
    }

    const currentToolMode = docViewer.getToolMode().name;
    if (docId && shape) {
      const documentEl = documentElement(docId);

      if (!documentEl) {
        return false;
      }

      if (styles) {
        this.setToolStyles(docId, shape, styles);
      }

      if (currentToolMode && currentToolMode !== getToolNameByType(shape)) {
        this.currentToolMode = source;

        const tool = this.getToolByType(docId, shape);
        // console.warn('tool: ', tool);
        // console.warn('shape: ', shape);
        docViewer.setToolMode(tool as Core.Tools.Tool);
      }

      this.toolToggled.emit({ source, shape, isEnabled: true });
      return true;
    }
    return false;
  }

  getToolByType(docId: string, type: PdfToolType): Core.Tools.Tool | null {
    let docViewer = this.pdfInstanceManager.getDocViewer(docId);
    if (docViewer) {
      return docViewer.getTool(getToolNameByType(type)) ? docViewer.getTool(getToolNameByType(type)) : null;
    }
    return null;
  }

  setToolStyles(docId: string, type: PdfToolType, toolStyles: any, _saveOld: boolean = false): void {
    const tool = this.getToolByType(docId, type);

    if (tool) {
      tool.setStyles(toolStyles);
      // if (saveOld) {
      //   tool.setStyles((oldStyles) => ({
      //     ...oldStyles,
      //     ...toolStyles
      //   }));
      // } else {
      //   tool.setStyles(() => toolStyles);
      // }
    }
  }
}

export interface ToolEvent {
  source: ToolEventSource;
  shape?: PdfToolType;
  isEnabled: boolean;
}
